import React, { FC, useCallback } from 'react';
import { RichTextEditor } from 'components/atoms/rich-text-editor';
import { PLACEHOLDER } from 'components/organisms/task-pane/task-detail/task-fields/task-custom-fields/fields/constant';
import { MultiLineTextField as MultiLineTextFieldT } from 'components/organisms/tasks/fields';
import { useInput } from 'hooks/use-input';
import styles from './multi-line-text.module.css';

interface FieldProps {
  field: MultiLineTextFieldT;
  onChange?: (selected: string, field: MultiLineTextFieldT) => void;
  disabled: boolean;
  placeholder?: string;
}

export const MultiLineTextField: FC<FieldProps> = ({
  field,
  onChange,
  disabled,
  placeholder = PLACEHOLDER,
}) => {
  const { value = '' } = field;
  const [state, _, setState] = useInput(value || '');

  const commit = (latest: string) => {
    setState(latest);
    if (value !== latest) {
      if (onChange) {
        onChange(latest, field);
      }
    }
  };

  const enhancedBreaklineValue = useCallback(() => {
    return state.replaceAll('\n', '<br>');
  }, [state]);

  return (
    <RichTextEditor
      className={`${styles.multiline__rte__fields}`}
      data={enhancedBreaklineValue() ?? ''}
      onBlur={(e) => commit(e)}
      onChange={(_data) => setState?.(_data)}
      disallowMentions
      placeholder={placeholder}
      testId={`right.content.multi.line.${field.fieldLabel}`}
      noVariables
      readonly={disabled}
    />
  );
};
